import classnames from 'classnames/bind';
import { omit } from 'lodash';
import PropTypes from 'prop-types';
import React, { useContext, useEffect } from 'react';

import PrintLogo from '../../assets/default-print-logo.svg';
import IRTMessageBody from '../../components/IRTMessageBody/IRTMessageBody';
import MessageBody from '../../components/MessageBody/MessageBody';
import MessageCenterFooter from '../../components/MessageCenterFooter/MessageCenterFooter';
import ViewBody from '../../components/ViewBody/ViewBody';
import TRP from '../../shared/TRP/TRP';
import { callApi, VIEWED } from '../../utils/api';
import {
  displayHourMinuteSecond,
  displayLongDate,
  getCurrentYear
} from '../../utils/utils';
import WebViewContext from '../../utils/webview-context';
import styles from './View.module.scss';

const cx = classnames.bind(styles);

const View = ({
  additionalState: { selectedMessage } = {},
  apiKey,
  baseUrl,
  forcePrintView,
  openModal,
  sentMessageCache: sentMessages,
  theme,
  transition,
  viewSent = false
}) => {
  const isCustomerWebView = useContext(WebViewContext);
  useEffect(() => {
    (async function() {
      if (!isCustomerWebView) {
        if (selectedMessage && !selectedMessage.viewed) {
          selectedMessage.createdTimestamp = selectedMessage.createdTimestamp
            ? new Date(selectedMessage.createdTimestamp).getTime()
            : new Date().getTime();
          const toOmit = ['createTimestamp', 'expiresTimestamp', 'suppressed'];
          const isSentMessage =
            sentMessages &&
            sentMessages.some(
              sent => sent.messageId === selectedMessage.messageId
            );
          if (!isSentMessage) {
            if (selectedMessage.replyId === null) {
              selectedMessage.replyId = '-1';
            }
            const message = omit(selectedMessage, toOmit);
            callApi(baseUrl, apiKey, VIEWED, message);
          }
        }
      }
    })();
  }, []);
  return (
    <span className={cx({ 'force-print-view': forcePrintView })}>
      <span className={`e2e-page-view ${styles['page-view']}`}>
        <div className={styles['view-container']}>
          <h2 className={`${styles.header} branded-header`}>
            {`View ${viewSent ? 'Sent ' : ''}Message`}
          </h2>
          <div className={`${styles['view-main']} blocked_data`}>
            <ViewBody
              message={selectedMessage}
              openModal={openModal}
              theme={theme}
              transition={transition}
              viewSent={viewSent}
            />
          </div>
          <MessageCenterFooter />
        </div>
      </span>
      <span className={styles['print-view']}>
        <header>
          <img alt="logo" className={styles['print-logo']} src={PrintLogo} />
        </header>
        <p
          className={`${styles['message-subject']} ${styles['message-label']}`}
          dangerouslySetInnerHTML={{
            __html: selectedMessage.subject || ''
          }}
        ></p>
        <p className={styles['message-date']}>
          <span className={styles['message-label']}>Date: </span>
          {displayLongDate(selectedMessage.createdTimestamp)}{' '}
          {displayHourMinuteSecond(selectedMessage.createdTimestamp)}
        </p>
        <div className={`blocked_data ${styles['message-label']}`}>
          Message Details:
        </div>

        {selectedMessage.isIrt ? (
          <IRTMessageBody {...selectedMessage} />
        ) : (
          <MessageBody {...selectedMessage} />
        )}
        <footer>
          Copyright 1996 - {getCurrentYear()}, <TRP /> Investment Services,
          Inc., Distributor. All rights reserved.
        </footer>
      </span>
    </span>
  );
};

View.propTypes = {
  additionalState: PropTypes.object,
  apiKey: PropTypes.string,
  baseUrl: PropTypes.string,
  forcePrintView: PropTypes.bool,
  openModal: PropTypes.func,
  selectedMessage: PropTypes.object,
  sentMessageCache: PropTypes.array,
  theme: PropTypes.oneOf(['ak529']),
  transition: PropTypes.func,
  viewSent: PropTypes.bool,
  webViewEnabled: PropTypes.bool
};

export default View;
